import { fetchApi } from "containers/helpers";

export const getMeetings = () => fetchApi('/meetings')